import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { isMobile } from 'react-device-detect';
import { withRouter } from 'react-router-dom';
import AppHeader from '@/layouts/AppHeader';
import AppSidebar from '@/layouts/AppSidebar';
import { fetchFilters } from '@/redux/actions/filterActions';

const { Content } = Layout;

class AppLayout extends Component {

    state = {
        collapsed: false
    };

    checkAndCollapse = (pathname) => {
        if (pathname.includes('messenger')
            //|| pathname.startsWith('/customer/')
        ) {
            this.setState({ collapsed: true });
        } else {
            this.setState({ collapsed: false });
        }
    };

    componentDidMount() {
        // Chạy khi reload trang
        this.checkAndCollapse(this.props.location.pathname);

        // (Optional) lắng nghe thay đổi route liên tục
        this.unlisten = this.props.history.listen((location) => {
            this.checkAndCollapse(location.pathname);
        });
        this.props.dispatch(fetchFilters());
    }

    componentDidUpdate(prevProps) {
        // Chạy khi chuyển route bằng Link/Push
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.checkAndCollapse(this.props.location.pathname);
        }
    }

    componentWillUnmount() {
        this.unlisten && this.unlisten();
    }


    handleSidebarCollapse = (collapsed) => {
        this.setState({ collapsed });
    };

    render() {
        const { collapsed } = this.state;
        const { location } = this.props;

        const shouldShowHeader = !(isMobile && location.pathname.includes('customer-data'));
        const headerHeight = 48;
        const marginLeft = isMobile ? 0 : (collapsed ? 55 : 250);

        return (
            <div>
                <div className="ios-status-bar-fake" />
                {shouldShowHeader && (
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            zIndex: 999,
                            height: headerHeight,
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                        }}
                    >
                        <AppHeader />
                    </div>
                )}

                <Layout style={{ paddingTop: shouldShowHeader ? headerHeight : 0 }}>
                    {!isMobile && (
                        <AppSidebar
                            collapsed={collapsed}
                            onCollapse={this.handleSidebarCollapse}
                            location={location}
                        />
                    )}

                    <Layout style={{ marginLeft, transition: 'all 0.2s' }}>
                        <Layout style={{ padding: `0 ${isMobile ? '8px' : '15px'} 15px`, minHeight: '95vh' }}>
                            <Content className="content-wrapper">
                                {this.props.children}
                            </Content>
                        </Layout>
                    </Layout>
                </Layout>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    authUser: state.auth.authUser
});

export default connect(mapStateToProps)(withRouter(AppLayout));